// extracted by mini-css-extract-plugin
export default {"explanation":"TypeExplanation_explanation__NNDZw"};